export const STRINGS = {
  appTitle: "VB Trails",
  mapViewTitle: "Map",
  listViewTitle: "Discover Trails",
  filterViewTitle: "Filter Trails",
  detailsViewTitle: "Trail Details",
  legendsViewTitle: "Legends",
  dataUnavailable: "Data Unavailable",
  filterResults: "Filter Results",
  reset: "Reset",
  status: "Status",
  property: "Property",
  propertyType: "Property Type",
  trailDifficulty: "Trail Difficulty",
  facilityType: "Facility Type",
  surfaceType: "Surface Type",
  category: "Category",
  routeName: "Route Name",
  trailLength: "Trail Length",
  trailWidth: "Trail Width",
  trailStatus: "Trail Status",
  from: "From",
  to: "To",
  is: "is",
  noDesc: "No description available.",
  shareCancelled: "Share Cancelled",
  resetMap: "Reset Map",
  domainHost: "https://vbtrails.virginiabeach.gov",
  filter: "Filter",
  information: "Information",
  mapMarker: "Map marker",
  mapMarkerSelected: "Map marker selected",
  moderate: "Moderate",
  stateTrails: "State Trails",
  cityTrails: "City Trails",
};
